export default __webpack_public_path__ + "static/media/logo-us-Williams.6aa0d66f.svg";